import type { RouteObject } from "react-router";
import { EVENT_ROUTES } from "../constants/event-routes";

export const eventRoutes: RouteObject = {
	children: [
		{
			path: EVENT_ROUTES.LIST,
			lazy: async () => {
				const { default: EventsPage } = await import("../pages/events-page");
				return { Component: EventsPage };
			},
		},
		{
			path: EVENT_ROUTES.CREATE,
			lazy: async () => {
				const { default: EventCreatePage } = await import("../pages/event-create-page");
				return { Component: EventCreatePage };
			},
		},
		{
			path: EVENT_ROUTES.PREVIEW,
			lazy: async () => {
				const { default: EventPreviewPage } = await import("../pages/event-preview-page");
				return { Component: EventPreviewPage };
			},
		},
		{
			path: EVENT_ROUTES.DETAIL,
			lazy: async () => {
				const { default: EventDetailPage } = await import("../pages/event-detail-page");
				return { Component: EventDetailPage };
			},
		},
		{
			path: EVENT_ROUTES.EDIT,
			lazy: async () => {
				const { default: EventEditPage } = await import("../pages/event-edit-page");
				return { Component: EventEditPage };
			},
		},
	],
};

export const eventPublicRoutes: RouteObject = {
	path: EVENT_ROUTES.PUBLIC_DETAIL,
	lazy: async () => {
		const { default: PublicEventPage } = await import("../pages/public-event-page");
		return { Component: PublicEventPage };
	},
};
